export default __webpack_public_path__ + "static/media/profile.56baa22e.svg";